module.exports = __webpack_public_path__ + "img/nav-write.16d3cba6.svg";